import { loadGSAP } from "./helpers";
import { ArticleModel, currentBackgroundAnimation } from "./types";

const kartta = async (model: ArticleModel): currentBackgroundAnimation => {
	const gsap = await loadGSAP()
	console.log(gsap)
  const tausta = document.getElementById("tausta-kartta_tausta_hires");

  const nuppineula = document.getElementById(
    "tausta-kartta_tausta_hires-extralayer-0"
  );
  const kartta = document.getElementById(
    "tausta-kartta_tausta_hires-extralayer-1"
  );
  if (!tausta || !nuppineula || !tausta) return;
  const elementsToAnimate = [tausta, nuppineula, kartta];

const tl = gsap.timeline();

  return {
    run: () => {


      tl.to(elementsToAnimate, {
        backgroundPositionX: 100,
        backgroundPositionY: 50,
        delay: 0.5,
        duration: 0.5,
        ease: "power0.easeNone",
      });

      tl.to(elementsToAnimate, {
        backgroundSize: 200,
        delay: 0,
        duration: 1,
        ease: "power4.easeout",
      });
    },
    destroy: (newBackground?: string) => {
	tl.time(0);
	tl.kill();
	return
    }
}
};

const pitkanuoruus = async (model: ArticleModel): currentBackgroundAnimation => {
	const tausta = document.getElementById("tausta-vuosi1180_3000x5333");
      
	const gsap = await loadGSAP()
	if (!tausta) return;
	const elementsToAnimate = tausta;
      
        const tl = gsap.timeline();
	return {
	  run: () => {
		tl.to(elementsToAnimate, {
	      backgroundPositionX: 50,
	      backgroundPositionY: 60,
	      delay: 1,
	      duration: 0.5,
	      ease: "power0.easeNone",
	    });
      
	    tl.to(elementsToAnimate, {
	      backgroundSize: 300,
	      delay: 0.5,
	      duration: 1,
	      ease: "power4.easeout",
	    });
	  },
	  destroy:(newBackground?: string) => {
		if(newBackground === "vuosi1180_3000x5333") return
		setTimeout(e=> {
			elementsToAnimate.style.backgroundPosition = "0% 0%";
			elementsToAnimate.style.backgroundSize = "100%";
		}, 600)

//	      tl.time(0);
	      tl.kill();
	      return
	  }
      }
};


const suurkaupunki = async (model: ArticleModel): currentBackgroundAnimation => {
	const tausta = document.getElementById("tausta-vuosi1180_3000x5333");
      
	const gsap = await loadGSAP()
	if (!tausta) return;
	const elementsToAnimate = tausta;
      
        const tl = gsap.timeline();
      
	return {
	  run: () => {
	    tl.to(elementsToAnimate, {
	      backgroundPositionX: 45,
	      backgroundPositionY: 30,
	      delay: 0,
	      duration: 0.5,
	      ease: "power1.in",
	    });
      
	    tl.to(elementsToAnimate, {
	      backgroundSize: 300,
	      delay: 1,
	      duration: 0.5,
	      ease: "power1.in",
	    });
	  },
	  destroy:(newBackground?: string) => {
		if(newBackground === "vuosi1180_3000x5333") return
	      tl.time(0);
	      tl.kill();
	      return
	  }
      }
};

const dinosaurukset = async (model: ArticleModel): currentBackgroundAnimation => {
	const tausta = document.getElementById("tausta-vuosi1180_3000x5333");
      
	const gsap = await loadGSAP()
	if (!tausta) return;
	const elementsToAnimate = tausta;
      
        const tl = gsap.timeline();
      
	return {
	  run: () => {
	    tl.to(elementsToAnimate, {
	      backgroundPositionX: 45,
	      backgroundPositionY: 0,
	      delay: 0,
	      duration: 0.5,
	      ease: "power1.in",
	    });
      
	    tl.to(elementsToAnimate, {
	      backgroundSize: 300,
	      delay: 1,
	      duration: 0.5,
	      ease: "power1.in",
	    });
	  },
	  destroy: (newBackground?: string) => {
		return
		console.log(newBackground)
		if(newBackground === "vuosi1180_3000x5333" || newBackground === "1882_2") return
		if(newBackground === "vuosi1180_3000x5333" || newBackground === "1882_2")
		tl.time(0);
	      tl.kill();
	  }
      }
};



export const backgroundAnimations = {
  kartta,
  pitkanuoruus,
  suurkaupunki,
  dinosaurukset
};
